import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import GallerySection from '../Components/Gallery';
import FooterSection from '../Components/Footer';

const gallery = () => (
  <PageStyle>
    <GallerySection />
    <FooterSection />
  </PageStyle>
);

export default gallery;
